/* Border treatments a trader's goods might need, from the monthly HMRC
 * tariff build (Models/CustomsProfiles.js, rules in
 * system/server/lib/tariffFlags.js — keys match its FLAGS). Search rows carry
 * customs_treatments: ['port_health', ...], [] for none found, null for no data.
 * matchesTreatments mirrors system/server/lib/searchFilters.js — CHANGE ONE,
 * CHANGE THE OTHER (the release digest applies saved filters server-side).
 * No complexity score: tried and dropped as ambiguous (John, 2026-10-01). */

import { useAuth } from '@/context/AuthContext';

export const TREATMENT_OPTIONS = [
    { key: 'port_health', label: 'Port health', control: true, hint: 'Food, animal or plant goods — border health checks (CHED, phytosanitary)' },
    { key: 'cites', label: 'CITES', control: true, hint: 'Endangered-species goods — CITES permits' },
    { key: 'licence', label: 'Licence', control: true, hint: 'Import or export licence — firearms, controlled drugs, restricted goods' },
    { key: 'excise', label: 'Excise', control: true, hint: 'Alcohol, tobacco, fuel — excise duty, bonded warehousing' },
    { key: 'anti_dumping', label: 'Anti-dumping', control: true, hint: 'Extra duty on these goods from certain countries' },
    { key: 'high_duty', label: 'High duty', control: false, hint: 'Standard import duty of 8% or more, or a fixed charge' },
    { key: 'quota', label: 'Quota', control: false, hint: 'A lower duty rate under a quota that can run out' },
    { key: 'preference_saving', label: 'Trade deal', control: false, hint: 'A much lower duty rate under a trade deal, if preference is claimed' },
];
const BY_KEY = new Map(TREATMENT_OPTIONS.map((o) => [o.key, o]));

export const treatmentOption = (key) => BY_KEY.get(key) || null;

export const offeredTreatments = (keys) => (keys || []).filter((k) => BY_KEY.has(k));

// Keep a trader whose goods might need ANY chosen treatment.
export const matchesTreatments = (trader, keys) => {
    const chosen = offeredTreatments(keys);
    return !chosen.length || chosen.some((k) => (trader.customs_treatments || []).includes(k));
};

/* Org setting (Settings page, owners): an org can turn the customs
 * information off. On unless organizations.customs_profile_enabled is 0. */
export const customsEnabled = (user) => {
    const flag = user?.organization?.customs_profile_enabled;
    return flag !== 0 && flag !== false;
};

export const useCustomsEnabled = () => customsEnabled(useAuth()?.user);
